import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Card, Button } from 'antd';
import PropTypes from 'prop-types';
import { request } from '../utils/http';

const CacheItem = forwardRef(({ countUrl, onClear, name, label }, ref) => {
	const [cacheCount, setCacheCount] = useState(null);

	const updateCacheCount = async () => {
		const result = await request('GET', countUrl);

		if (result) {
			setCacheCount(result);
		} else {
			setCacheCount(0);
		}
	};

	// Expose the updateCacheCount function to the parent via ref
	useImperativeHandle(ref, () => ({
		updateCacheCount,
	}));

	useEffect(() => {
		if (!cacheCount && countUrl !== '') {
			updateCacheCount();
		}
	}, [cacheCount, countUrl]);

	return (
		<Card
			title={name}
			extra={
				onClear !== null && (
					<Button type='danger' size='default' icon='delete' onClick={() => onClear()}>
						Rensa
					</Button>
				)
			}
		>
			{cacheCount !== null && (
				<p>
					<b>{label || 'Antal nycklar'}: </b>
					{cacheCount}
				</p>
			)}
		</Card>
	);
});

CacheItem.defaultProps = {
	countUrl: '',
};

CacheItem.propTypes = {
	countUrl: PropTypes.string,
	onClear: PropTypes.func,
	name: PropTypes.string.isRequired,
};

export default CacheItem;

export { CacheItem };



// WEBPACK FOOTER //
// ./src/components/cacheItem.jsx